import { Box, chakra } from '@chakra-ui/react';
import React from 'react';

interface Props {
  className?: string;
  children: React.ReactNode;
}

const Content = ({ children, className }: Props) => {
  return (
    <Box pt={{ base: 0, lg: '52px' }} as="main" className={ className }
    sx={{
        // '@media screen and (min-width: 0px) and (max-width: 767px)': {
        //   marginTop: '52px',
        // },
        '@media screen and (min-width: 0px) and (max-width: 413px)': {
          marginTop: '52px',  
          width: '95%',
          justifySelf: 'center',
        },
        '@media screen and (min-width: 414px) and (max-width: 999px)': {
          marginTop: '52px',
          width: '80%',
          justifySelf: 'center',
        },
      }}
    >
      { children }
    </Box>
  );
};

export default React.memo(chakra(Content));
